/**
 * KIT outbound-click analytics — fire-and-forget.
 *
 * Failure MUST NEVER block the Amazon link. The Amazon anchor uses
 * `target="_blank"` so the OnSetFlow tab stays open, but we still
 * request `keepalive: true` so the beacon survives if the user
 * backgrounds the app on mobile immediately after tapping.
 *
 * We deliberately do NOT use axios here: the axios instance is
 * request-Promise-oriented and doesn't expose `keepalive`. A raw
 * `fetch` with a bearer token is enough and keeps this helper
 * dependency-free.
 */

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Log an outbound "View on Amazon" click.
 *
 * @param {object} event
 * @param {string} event.department      e.g. "hair_makeup"
 * @param {string} event.category_slug   e.g. "hygiene-disposables"
 * @param {string} event.product_id      stable product id from the manifest
 * @param {string} [event.asin]          Amazon ASIN if present
 */
export function logKitOutbound(event) {
    try {
        const token = localStorage.getItem("token");
        if (!token || !BACKEND) return;
        const body = JSON.stringify({
            department: event.department,
            category_slug: event.category_slug,
            product_id: event.product_id,
            asin: event.asin || null,
        });
        // Fire-and-forget. No await, no error surfacing.
        fetch(`${BACKEND}/api/kit/outbound`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body,
            keepalive: true,
        }).catch(() => { /* swallow — must never block link */ });
    } catch {
        // Anything unexpected (SSR, storage disabled, etc.) is
        // silently dropped so the outbound link is unaffected.
    }
}
